const CryptoJS = require('crypto-js');

export default class CryptoJsAdapter {
  static aesEncrypt(cipherText, secret_key) {
    return CryptoJS.AES.encrypt(cipherText, secret_key).toString();
  };

  static aesDecrypt(decryptedText, secret_key) {
    let bytes = CryptoJS.AES.decrypt(decryptedText, secret_key);
    let decrypted_text = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted_text;
  };
}